// extracted by mini-css-extract-plugin
module.exports = {"main-header":"header_main-header__qwoDX"};